export default __webpack_public_path__ + "static/2-fb2e39fc6cd0225b63f6466888af745f.jpg";